import '.do{font-size:1.125rem;}.ssr-plugin'
import '.em{line-height:1.75rem;}.ssr-plugin'
import '.ic{text-decoration:none;}.ssr-plugin'
import '.dn{color:var(--primary-red);}.ssr-plugin'
import { pages } from '@app/util/links'
import { useTranslations } from '@i18n/useLanguage'
import { styled } from 'inlines'

export const TermsAndConditions = () => {
  const translations = useTranslations().app.auth
  return (
    <p className="do em"
    >
      {translations.privacySubtitle}{' '}
      <a className="ic dn"
        href={pages.legal}
        target="_blank"
        rel="noopener noreferrer"
      >
        {translations.privacyStatementLink}
      </a>{' '}
      {translations.privacySubtitleAnd}{' '}
      <a className="ic dn"
        href={pages.legal}
        target="_blank"
        rel="noopener noreferrer"
      >
        {translations.termsAndConditionsLink}
      </a>
    </p>
  )
}
